import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Added for navigation
import '../css/AddressSelection.css';

const AddressSelection = () => {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [error, setError] = useState('');
  const [showAddAddressForm, setShowAddAddressForm] = useState(false);
  const [newAddress, setNewAddress] = useState({
    type: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
  });
  const [addressError, setAddressError] = useState('');

  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Please login to see your addresses.');
      return;
    }

    axios.get(`${process.env.REACT_APP_API_URL}/api/user/getAddress`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      setAddresses(response.data);
      if (response.data.length > 0) {
        setSelectedAddress(response.data[0].id);
      }
    })
    .catch(() => {
      setError('Failed to load addresses.');
    });
  }, []);

  const handleSelect = (id) => {
    setSelectedAddress(id);
    setAddressError('');
  };

  const handleSubmit = () => {
    if (!selectedAddress) {
      setAddressError('Please select an address.');
    } else {
      setAddressError('');
      navigate(`/orderSelection/${selectedAddress}`); // Navigate to OrderSelection
    }
  };

  const handleAddAddressToggle = () => {
    setShowAddAddressForm(!showAddAddressForm);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddAddressSubmit = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Please login to add an address.');
      return;
    }

    axios.post(`${process.env.REACT_APP_API_URL}/api/user/addAddress`, newAddress, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      setAddresses((prevAddresses) => [...prevAddresses, response.data]);
      setShowAddAddressForm(false);
      setNewAddress({
        type: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
      });
    })
    .catch(() => {
      setError('Failed to add address.');
    });
  };

  if (error) {
    return <div className="error-box">{error}</div>;
  }

  return (
    <div className="address-selection-container">
      <h2>Select Your Address</h2>
      {addresses.length === 0 ? (
        <p>No addresses found.</p>
      ) : (
        <div className="address-list">
          {addresses.map((address) => (
            <div key={address.id} className="address-item">
              <input
                type="radio"
                id={`address-${address.id}`}
                name="address"
                value={address.id}
                checked={selectedAddress === address.id}
                onChange={() => handleSelect(address.id)}
              />
              <label htmlFor={`address-${address.id}`} className="address-label">
                <div className="address-type">{address.type}</div>
                <div className="address-details">
                  <p>{address.addressLine1}, {address.addressLine2}</p>
                  <p>{address.city}, {address.state}, {address.postalCode}</p>
                  <p>{address.country}</p>
                </div>
              </label>
            </div>
          ))}
        </div>
      )}

      {addressError && <div className="error-box">{addressError}</div>}

      <button className="submit-btn" onClick={handleSubmit}>
        Confirm Selection
      </button>

      <button className="add-address-btn" onClick={handleAddAddressToggle}>
        Add Address
      </button>

      {showAddAddressForm && (
        <div className="add-address-form">
          <h3>Add New Address</h3>
          <form>
            <input
              type="text"
              name="type"
              placeholder="Address Type (e.g., Home, Office)"
              value={newAddress.type}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="addressLine1"
              placeholder="Address Line 1"
              value={newAddress.addressLine1}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="addressLine2"
              placeholder="Address Line 2"
              value={newAddress.addressLine2}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="city"
              placeholder="City"
              value={newAddress.city}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="state"
              placeholder="State"
              value={newAddress.state}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="postalCode"
              placeholder="Postal Code"
              value={newAddress.postalCode}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="country"
              placeholder="Country"
              value={newAddress.country}
              onChange={handleInputChange}
            />
            <button
              type="button"
              className="submit-btn"
              onClick={handleAddAddressSubmit}
            >
              Add Address
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddressSelection;
